"use strict";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _style = require("../utils/style");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n  animation-delay: -0.1s;\n  left: 0;\n  bottom: 0;\n"]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n  animation-delay: -0.4s;\n  right: 0;\n  bottom: 0;\n"]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n  animation-delay: -0.7s;\n  top: 0;\n  right: 0;\n"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n  top: 0;\n  left: 0;\n  animation-delay: -1s;\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n  animation-delay: -0.2s;\n  left: 0;\n  bottom: 0;\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  animation-delay: -0.5s;\n  right: 0;\n  bottom: 0;\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  animation-delay: -0.8s;\n  top: 0;\n  right: 0;\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  top: 0;\n  left: 0;\n  animation-delay: -1.1s;\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  animation-delay: -0.3s;\n  left: 0;\n  bottom: 0;\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  animation-delay: -0.6s;\n  right: 0;\n  bottom: 0;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  animation-delay: -0.9s;\n  top: 0;\n  right: 0;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  top: 0;\n  left: 0;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  transform: rotateZ(90deg);\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  transform: rotateZ(45deg);\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  width: ", ";\n  height: ", ";\n  background-color: ", " ;\n  border-radius: 100%;\n  position: absolute;\n  animation: ", " ", "s infinite ease-in-out;\n  animation-fill-mode: both;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 100%;\n  height: 100%;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 48px;\n  height: 48px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  0%,\n  80%,\n  100% {\n    transform: scale(0);\n    -webkit-transform: scale(0);\n  }\n  40% {\n    transform: scale(1);\n    -webkit-transform: scale(1);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var bouncedelay = (0, _styledComponents.keyframes)(_templateObject());

var LoadContainer = _styledComponents.default.div(_templateObject2());

var container = _styledComponents.default.div(_templateObject3());

var circle = _styledComponents.default.div(_templateObject4(), function (props) {
  return _style.sizeItem[props.size] || _style.sizeItem['default'];
}, function (props) {
  return _style.sizeItem[props.size] || _style.sizeItem['default'];
}, function (props) {
  return props.color || '#00adb5';
}, bouncedelay, function (props) {
  return props.speed || 1.2;
});

var ContainerFirst = (0, _styledComponents.default)(container)(_templateObject5());
var ContainerTwo = (0, _styledComponents.default)(container)(_templateObject6());
var ContainerThree = (0, _styledComponents.default)(container)(_templateObject7());
var CircleFirst = (0, _styledComponents.default)(circle)(_templateObject8());
var CircleTwo = (0, _styledComponents.default)(circle)(_templateObject9());
var CircleThree = (0, _styledComponents.default)(circle)(_templateObject10());
var CircleFour = (0, _styledComponents.default)(circle)(_templateObject11());
var CircleFirst1 = (0, _styledComponents.default)(circle)(_templateObject12());
var CircleTwo1 = (0, _styledComponents.default)(circle)(_templateObject13());
var CircleThree1 = (0, _styledComponents.default)(circle)(_templateObject14());
var CircleFour1 = (0, _styledComponents.default)(circle)(_templateObject15());
var CircleFirst2 = (0, _styledComponents.default)(circle)(_templateObject16());
var CircleTwo2 = (0, _styledComponents.default)(circle)(_templateObject17());
var CircleThree2 = (0, _styledComponents.default)(circle)(_templateObject18());
var CircleFour2 = (0, _styledComponents.default)(circle)(_templateObject19());

var LoopCircleLoading = function LoopCircleLoading(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? _style.commonStyle : _ref$style,
      color = _ref.color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "default" : _ref$size,
      speed = _ref.speed;
  return _react.default.createElement(LoadContainer, {
    style: style
  }, _react.default.createElement(ContainerFirst, null, _react.default.createElement(CircleFirst, {
    color: color,
    size: size,
    speed: speed
  }), _react.default.createElement(CircleTwo, {
    color: color,
    size: size,
    speed: speed
  }), _react.default.createElement(CircleThree, {
    color: color,
    size: size,
    speed: speed
  }), _react.default.createElement(CircleFour, {
    color: color,
    size: size,
    speed: speed
  })), _react.default.createElement(ContainerTwo, null, _react.default.createElement(CircleFirst1, {
    color: color,
    size: size,
    speed: speed
  }), _react.default.createElement(CircleTwo1, {
    color: color,
    size: size,
    speed: speed
  }), _react.default.createElement(CircleThree1, {
    color: color,
    size: size,
    speed: speed
  }), _react.default.createElement(CircleFour1, {
    color: color,
    size: size,
    speed: speed
  })), _react.default.createElement(ContainerThree, null, _react.default.createElement(CircleFirst2, {
    color: color,
    size: size,
    speed: speed
  }), _react.default.createElement(CircleTwo2, {
    color: color,
    size: size,
    speed: speed
  }), _react.default.createElement(CircleThree2, {
    color: color,
    size: size,
    speed: speed
  }), _react.default.createElement(CircleFour2, {
    color: color,
    size: size,
    speed: speed
  })));
};

var _default = LoopCircleLoading;
exports.default = _default;